module.exports = __webpack_public_path__ + "img/cargo-wagon-door-vertical-side-mask.a89e37f9.png";